import { isInProgress, } from './state.js';
import { getPlayerHand } from './trick.js';
export function getOhHellPlayerState(state, playerId) {
    if (!isInProgress(state)) {
        return state;
    }
    const currentRound = getPlayerRound(state.currentRound, playerId);
    return {
        players: state.players,
        roundsToPlay: state.roundsToPlay,
        completedRounds: state.completedRounds,
        currentRound,
        playerId,
    };
}
export function isPlayerState(state) {
    return !!state.playerId;
}
export function getPlayerRound(round, playerId) {
    const hand = getPlayerHand(round.hands, playerId);
    const trickWinnerIds = round.completedTricks.map((trick) => trick.winnerId);
    return {
        deckCode: round.deckCode,
        players: round.players,
        dealerPlayerId: round.dealerPlayerId,
        turnPlayerId: round.turnPlayerId,
        bids: round.bids,
        hand,
        trickWinnerIds,
        completedTricks: round.completedTricks,
        currentTrick: round.currentTrick,
        readyForCommands: round.readyForCommands,
        trumpCard: round.trumpCard,
        trumpSuit: round.trumpSuit,
        roundNumber: round.roundNumber,
        roundName: round.roundName,
        numberOfCards: round.numberOfCards,
    };
}
//# sourceMappingURL=playerState.js.map